import Button from "@/common/components/Button";
import { ShowHeader } from "@/common/components/ShowHeader";
import { useGoBack } from "@/common/hooks/useGoBack";
import { maintenanceForwardingsDirectiveEntryKlasses } from "@/features/maintenance/features/workflows/constants/forwardings/maintenanceForwardingsDirectiveEntryKlasses.constant";
import { MaintenanceEstablishmentChoiceAuctionEntryUpdatedSummaryData } from "../../../types/updatedSummary.type";

interface MaintenanceEstablishmentChoiceEntryAuctionHeaderProps {
  actions?: JSX.Element;
  showCancelButton?: boolean;
  auctionSummary: MaintenanceEstablishmentChoiceAuctionEntryUpdatedSummaryData | undefined;
  auctionSummaryIsPending: boolean;
}

const MaintenanceEstablishmentChoiceEntryAuctionHeader = ({
  actions,
  showCancelButton,
  auctionSummary,
  auctionSummaryIsPending,
}: MaintenanceEstablishmentChoiceEntryAuctionHeaderProps) => {
  const goBack = useGoBack();

  return (
    <ShowHeader
      goBack
      goBackProps={{
        fallback: `/maintenance-establishment-choice/auction-entries`,
        searchLastRouteFromFallback: true,
      }}
      title={
        `Leilão ${auctionSummary?.directive_entry_type
          ? `(${maintenanceForwardingsDirectiveEntryKlasses[auctionSummary?.directive_entry_type]?.label})`
          : ''}`
      }
      isLoading={auctionSummaryIsPending}
      subtitle={auctionSummary?.equipment_model_name}
      titleClassName="text-md"
      className="text-white-400"
      subtitleClassName="text-nowrap font-medium"
      buttons={(
        <div className="flex items-center gap-3">
          {showCancelButton && (
            <Button
              variant="outline-error"
              onClick={() => goBack({
                fallback: `/maintenance-establishment-choice/auction-entries`,
                searchLastRouteFromFallback: true,
              })}
            >
              Cancelar
            </Button>
          )}

          {actions}
        </div>
      )}
    />
  );
}

export default MaintenanceEstablishmentChoiceEntryAuctionHeader;
